/**
 * Scripts in this file will be added to the site via theme.liquid layout (found inside the dist/layout directory) using the asset-router-js.liquid snippet )
 * for more info on theme layouts see: https://shopify.dev/tutorials/develop-theme-layouts
 *
 * Compiles to ./dist/assets/scripts/layout.theme.js
 */

/* eslint-disable no-unused-vars */

/* **** Note **** strictly coupled template scripts should not be imported here. They are
are added conditionallly via the asset-router-js.liquid file. This helps keep the code more lean  */

// Import ES6 modules (recommended)
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'what-input';
import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';
import { cookiesEnabled } from '@shopify/theme-cart';
import responsiveBackgroundImages from '../utilities/responsive-background-images';
import 'ACCESSIBILITY/focusFormErrors';
import 'UTILS/forms/handleVariantChange';
import 'COMPONENTS/age-gate';
import 'COMPONENTS/product-card';
import headerController from 'COMPONENTS/headerController';
import navigationController from 'COMPONENTS/navigationController';

// Common a11y fixes
focusHash();
bindInPageLinks();
headerController.init();
navigationController.init();

// Apply a specific class to the html element for browser support of cookies.
// if (cookiesEnabled()) {
//   document.documentElement.className = document.documentElement.className.replace(
//     'supports-no-cookies',
//     'supports-cookies',
//   );
// }

var modal = new tingle.modal({
  footer: true,
  stickyFooter: false,
  closeMethods: ['overlay', 'button', 'escape'],
  closeLabel: 'Close',
  cssClass: ['custom-class-1', 'custom-class-2'],
  onOpen: function () {
    console.log('modal open');
  },
  onClose: function () {
    console.log('modal closed');
  },
  beforeClose: function () {
    // here's goes some logic
    // e.g. save content before closing the modal
    return true; // close the modal
    return false; // nothing happens
  },
});
